export default "__VITE_ASSET__bfd24f89__"